import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState({ state: "checking", skin_id: null });

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) {
      nav("/pilot", { replace: true });
      return;
    }
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const r = await fetch(`${API}/api/payments/status/${sid}`, { credentials: "include" });
        const d = await r.json();
        if (cancelled) return;
        if (d.payment_status === "paid") {
          setStatus({ state: "paid", skin_id: d.skin_id });
          return;
        }
        if (["failed", "expired"].includes(d.payment_status)) {
          setStatus({ state: "failed", skin_id: null });
          return;
        }
      } catch (err) {
        console.warn("[payment] status poll failed:", err);
      }
      if (attempts < 15) setTimeout(poll, 2000);
      else if (!cancelled) setStatus({ state: "timeout", skin_id: null });
    };
    poll();
    return () => { cancelled = true; };
  }, [params, nav]);

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black text-white p-6">
      <div className="max-w-md w-full rounded-sm border border-primary/40 bg-black/90 p-8 space-y-6 text-center" data-testid="payment-success-panel">
        {status.state === "checking" && (
          <>
            <Loader2 className="h-10 w-10 mx-auto text-primary animate-spin" />
            <p className="font-mono text-[10px] tracking-[0.3em] text-secondary">// AGUARDANDO CONFIRMAÇÃO</p>
            <h2 className="font-display font-black text-3xl tracking-tighter">Processando transmissão...</h2>
            <p className="text-sm text-muted-foreground">Confirmando pagamento com a rede intergaláctica.</p>
          </>
        )}
        {status.state === "paid" && (
          <>
            <CheckCircle2 className="h-10 w-10 mx-auto text-primary" />
            <p className="font-mono text-[10px] tracking-[0.3em] text-primary">// SINAL RECEBIDO</p>
            <h2 className="font-display font-black text-3xl tracking-tighter">SKIN DESBLOQUEADA</h2>
            <p className="text-sm text-muted-foreground">Sua nova nave está no hangar. Volte ao cockpit para equipá-la.</p>
            <button
              onClick={() => nav("/pilot?openShop=1&justBought=" + (status.skin_id || ""))}
              data-testid="payment-success-continue"
              className="w-full rounded-sm bg-primary text-primary-foreground hover:bg-primary/90 font-mono tracking-widest text-xs px-5 py-3"
            >
              VOLTAR AO HANGAR ▶
            </button>
          </>
        )}
        {(status.state === "failed" || status.state === "timeout") && (
          <>
            <p className="font-mono text-[10px] tracking-[0.3em] text-red-400">// TRANSMISSÃO FALHOU</p>
            <h2 className="font-display font-black text-3xl tracking-tighter">Pagamento não confirmado</h2>
            <p className="text-sm text-muted-foreground">Nada foi cobrado. Tente novamente quando quiser.</p>
            <button onClick={() => nav("/pilot?openShop=1")} className="w-full rounded-sm border border-primary/40 hover:bg-primary/10 text-primary font-mono tracking-widest text-xs px-5 py-3">
              VOLTAR À LOJA
            </button>
          </>
        )}
      </div>
    </div>
  );
}
